<template>
	<b-row>
		<b-col
			class="steps-left d-none d-md-block"
			md="4"
		>
			<p>Almost done!</p>
			<div class="progress-outer">
				<div class="progress-inner"></div>
			</div>
			<ul>
				<li>
					<span>1</span> Move Information
				</li>
				<li>
					<span>2</span> Contact Information
				</li>
				<li>
					<span>3</span> Verify Phone
				</li>
				<li>
					<span>4</span> View Quote
				</li>
			</ul>
		</b-col>
		<b-col
			v-show="!showPhoneInput"
			class="verify-form"
			cols="12"
			md="8"
		>
			<b-row>
				<b-col>
					<h1 class="no-helper">
						Text Verification Code
					</h1>
				</b-col>
			</b-row>
			<div class="verify-items">
				<div
					class="input-wrap"
				>
					<masked-input
						v-if="!showPhoneInput"
						id="code"
						ref="code"
						v-model="code"
						:class="{ 'input-error': verify_error }"
						:disabled="loading"
						autofocus
						class="form-control code"
						mask="####"
						maxlength="4"
						name="code"
						required
						type="tel"
						@blur="onBlurCode"
						@focus="verify_error = false"
						@input="onInputCode"
						@keydown="onKeydownCode"
					/>
				</div>
				<div>
					<button
						:disabled="loading"
						type="button"
						@click="onSubmitCode"
					>
						<span v-if="!loading">Verify</span>
						<div
							v-else
							class="loader"
						/>
					</button>
				</div>
			</div>
			<b-row class="options">
				<b-col>
					<div class="verify-helper">
						<span v-if="!verify_error">Verification code sent to: {{ phoneDisplay }}</span>
						<span
							v-if="verify_error"
							class="verify-error"
						>
							Enter 4-digit code sent to: {{ phoneDisplay }}
						</span>
					</div>
					<div class="verify-opts">
						<a
							href="#"
							class="link"
							@click.prevent="togglePhoneInput"
						>
							Edit Number
						</a>
						<a
							v-if="!code_resent"
							href="#"
							class="link"
							@click.prevent="resendCode"
						>
							Resend Code
						</a>
						<span
							v-else
							class="link disabled"
						>
							Code Resent
							<span
								class="checkmark draw"
							/>
						</span>
					</div>
				</b-col>
			</b-row>
		</b-col>
		<b-col
			v-show="showPhoneInput"
			class="verify-form"
			cols="12"
			md="8"
		>
			<p
				class="phone-helper"
			>
				We'll send a text to verify your phone and our system will display your quote.
			</p>
			<h1>
				What’s your <b>phone number</b>?
			</h1>
			<div
				class="verify-items"
			>
				<div
					class="input-wrap"
				>
					<validate-field
						v-if="showPhoneInput"
						:disabled="validate.retry_phone.loading"
						:field-ph="inputPlaceholder"
						:focus="true"
						:on-change="editAndResend"
						field="retry_phone"
						field-text="phone number"
						field-value=""
					/>
				</div>
				<div>
					<button
						:disabled="isSubmitNewPhone"
						class="btn"
						type="submit"
					>
						<div
							v-if="isSubmitNewPhone && validate.retry_phone.isValid"
							class="loader"
						>
						</div>
						{{ !isSubmitNewPhone || !validate.retry_phone.isValid ? 'Continue' : '' }}
					</button>
				</div>
			</div>
		</b-col>
	</b-row>
</template>

<script>
import { mapState } from 'vuex';

import { TheMask } from 'vue-the-mask';

import ValidateField from '@/common/validate';

export default {
	name: 'QuoteTextVerify',

	components: {
		'masked-input': TheMask,
		ValidateField,
	},

	data() {
		return {
			code: '',
			code_resent: false,
			inputPlaceholder: '(     )   -    ',
			isSubmitting: false,
			loading: false,
			phone_retry: '',
			showPhoneInput: false,
			step: 8,
			verify_error: false,
		};
	},

	computed: {
		...mapState({
			quote: state => state.quote,
		}),
		isSubmitNewPhone() {
			return this.validate.retry_phone.loading || this.isSubmitting;
		},
		phone() {
			return this.quote.phone;
		},
		phoneDisplay() {
			const format = {
				areaCode: '',
				prefix: '',
				code: '',
			};

			if (this.phone) {
				format.areaCode = this.phone.slice(0, 3);
				format.prefix = this.phone.slice(3, 6);
				format.code = this.phone.slice(6, this.phone.length);
			}

			return `(${format.areaCode})  ${format.prefix} - ${format.code}`;
		},
		textId() {
			return this.quote.textVerifyId;
		},
		validate() {
			return this.$store.state.validator;
		},
	},

	watch: {
		showPhoneInput(curr, prev) {
			if (prev && !curr) {
				this.$nextTick(this.setFocusCode);
			}
		},
	},

	beforeRouteLeave(to, from, next) {
		if (to.name === 'Quote-Phone') {
			next(false);
		} else {
			next();
		}
	},

	mounted() {
		this.$store.dispatch('progress/updateProgress', this.step);

		this.$analytics.track('textVerify');

		this.$nextTick(() => {
			this.setFocusCode();
		});
	},

	methods: {
		editAndResend(field, model, isValid) {
			const editPhone = model;

			if (editPhone && isValid) {
				this.$analytics.page(
					'Resend_code',
					{ type: 'page', path: 'Resend_code' },
				);

				this.$store.dispatch('quote/update', {
					phone: model,
				})
					.then(() => {
						this.isSubmitting = true;
						this.resubmitLead();
					});
			}
		},
		resendCode() {
			this.resubmitLead(true);
		},
		resubmitLead(isResend = false) {
			const submitOptions = { leadType: 'move', isResubmit: true };

			this.$store.dispatch('quote/submitLead', submitOptions)
				.then(data => {
					this.$log.info('submitForm -> ', data);

					if (isResend) {
						this.$store.dispatch('quote/update', {
							textVerifyId: data.text_id,
						});

						this.code_resent = true;
						this.setFocusCode();
					} else {
						this.code_resent = false;
						this.showPhoneInput = false;
					}

					this.$store.commit('validator/RESET_FIELD', {
						field: 'retry_phone',
						touched: false,
						value: '',
					});
				})
				.catch(err => {
					this.$log.warn(err);
				})
				.finally(() => {
					this.isSubmitting = false;
				});
		},
		setFocusCode() {
			if (this.$refs.code) {
				this.$refs.code.$el.focus();
			}
		},
		togglePhoneInput: function() {
			this.showPhoneInput = true;

			this.$analytics.page(
				'Edit_number',
				{ type: 'page', path: 'Edit_number' },
			);

			this.$analytics.track('editPhone');

			setTimeout(function() {
				document.getElementById('retry_phone').focus();
			}, 1000);
		},
		verifyCode() {
			if (this.code && this.code.length === 4) {
				this.loading = true;
				this.$log.info('Text ID', this.textId);
				const validateUrl = `/text/validate/${this.code}`;

				this.$ireloApi
					.post(validateUrl, { text_id: this.textId })
					.then(resp => {
						if (!resp.data.success) {
							setTimeout(() => {
								this.loading = false;
								this.verify_error = true;
								this.code = '';

								this.$nextTick(this.setFocusCode);
							}, 1000);

							return false;
						}

						this.$analytics.track('textVerified');

						this.loading = false;

						this.$store.commit('validator/SET_VALID_STATE', {
							field: 'textVerify',
							isValid: true,
						});
					})
					.catch(err => {
						this.loading = false;
						this.verify_error = true;
						this.$log.error('verifyCode | ', err);
					});
			}
		},
		// EVENTS
		onBlurCode() {
			this.$log.debug(this.$refs.code);

			this.$nextTick(this.setFocusCode);

			if (this.code.length < 4) {
				this.verify_error = true;
			}
		},
		onInputCode() {
			this.verifyCode();
		},
		onKeydownCode: function(evt) {
			const keys = ['ArrowLeft', 'ArrowRight', 'Delete', 'Backspace'];

			if (
				!keys.includes(evt.key)	&& (evt.keyCode < 48 || evt.keyCode > 57)
			) {
				evt.preventDefault();

				return false;
			}

			return true;
		},
		onSubmitCode() {
			if (this.code && this.code.length === 4) {
				this.verifyCode();
			} else {
				this.onBlurCode();
			}
		},
	},
};
</script>

<style lang="scss">
@import "~@/common/validation";
.steps-left {
	border-right: 1px solid #a7a7a7;
	margin-top: 1rem;
	max-width: 32%;
	padding-bottom: 1.5rem;
	padding-top: 2rem;

	p,
	ul {
		color: #4a4a4a;
		font-size: 1rem;
		font-weight: 600;
		margin-bottom: 0.375rem;
		text-align: left;
	}

	ul {
		line-height: 2rem;
		list-style: none;
		margin-top: 1.25rem;
		padding-left: 0;

		span {
			padding-right: 10px;
		}

		li:last-child {
			color: #a7a7a7;
			font-weight: normal;
		}
	}
}

.verify-form {
	h1 {
		font-size: 1.9rem;
		margin: 5px 0 1.5rem 0;
		text-align: left;

		&.no-helper {
			margin-top: 50px;
		}
	}

	.phone-helper {
		color: #3bb671;
		font-size: 0.9rem;
		margin-top: 1.75rem;
	}

	.input-wrap {
		.loader {
			height: 25px;
			position: absolute;
			right: 0.5rem;
			top: 25%;
			width: 25px;

			&.edit {
				right: 8px;
				top: 8px;
			}
		}
	}
}

.verify-items {
	display: flex;
	height: 50px;

	.input-wrap {
		float: none;
		width: 100%;
	}

	input.form-control {
		border: none;
		border-bottom: 1px solid #a7a7a7;
		border-top-left-radius: 5px;
		border-top-right-radius: 5px;
		color: #4a4a4a;
		font-size: 1.25rem;
		font-weight: bold;
		height: 100%;
		width: 100%;

		&.code {
			background-color: rgba(100, 181, 217, 0.32);
			letter-spacing: 20px;
			margin-left: 0;
			padding-left: 0;
			text-align: center;
			width: 100%;

			&:focus {
				background-color: rgba(100, 181, 217, 0.32);
				outline: none;
			}
		}
	}

	button {
		height: 100%;
		margin-left: 15px;
	}
}

.options {
	margin-top: 15px;
}

.verify-helper {
	font-size: 0.9rem;
}

.verify-error {
	color: #c62121;
}

.verify-opts {
	color: #3bb671;

	.link {
		color: inherit;
		font-size: 0.9rem;
		position: relative;
		user-select: none;

		&:first-child {
			margin-right: 6px;
		}

		&:not(.disabled) {
			cursor: pointer;
		}

		&.disabled {
			color: #000000;
		}

		.checkmark {
			&::after {
				right: -0.75rem;
			}
		}
	}
}

// .verify-form {
// 	max-width: 100% !important;
// 	flex: 0 0 100% !important;
// 	display: flex;
// 	flex-direction: column;
// 	align-items: center;
// }

// h1.no-helper {
// 	margin-top: 15px !important;
// }

// h1 {
// 	font-size: 1.4rem !important;
// 	text-align: center !important;
// 	margin-left: 0 !important;
// }

// .phone-helper {
// 	width: 100% !important;
// 	text-align: center !important;
// 	margin-left: 0;
// }

// .verify-items {
// 	display: flex;
// 	flex-direction: column;
// 	align-items: center;
// 	height: auto;
// }

// .input-wrap input {
// 	margin-left: 0 !important;
// }

// .verify-items button {
// 	margin-top: 15px;
// 	margin-left: 0;
// }

// .options {
// 	width: 100%;
// 	display: flex;
// 	flex-direction: column;
// 	align-items: center;
// }

// .verify-helper {
// 	margin-left: 0;
// 	text-align: center;
// 	width: 100%;
// }
</style>
